module.exports = __webpack_public_path__ + "static/media/lighthouse.f05ef930.png";